/* SearchResultsLegacy.tsx generated by @compiled/babel-plugin v0.36.0 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["sort", "query"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _ = "@media (min-width:64rem){._u5gg1e76{margin-block:var(--_15020q)}}";
import { media } from '@atlaskit/primitives';
import { AppTile, PAGINATED_APP_GRID_CONFIG, PaginatedAppGrid } from '@atlassian/mpac-app-tile';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { breakpointValues, NoResultView, SortDropdown, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useEnvironment, useSource } from '@atlassian/mpac-utils';
import React, { useCallback, useState } from 'react';
import { useSearchPageAnalytics } from '../hooks/useSearchPageAnalytics';
import { GridHeader } from '../SearchResultPage.styles';
import { EndPageLabel, MatchingResultLabel } from '.';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const GridHeaderStyle = null;

// eslint-disable-next-line max-lines-per-function
export function SearchResults(_ref) {
  let {
    searchInputRef,
    gridProps,
    isSearchQueryActive,
    onSortOptionSelect,
    areFiltersActive,
    handleClearAllFilters,
    selectedSortKey,
    analyticsFilters,
    isAppInstalled,
    selectedHostingFilter
  } = _ref;
  const {
    totalCount,
    appList,
    isLoading,
    isLoadingMore,
    showLoadMoreButton,
    fetchMoreApps,
    initialFetchError,
    fetchMoreError,
    rawData
  } = gridProps;

  // we need to show loading
  // - when query is waiting to be fetched (!rawData && !initialFetchError)
  // - being fetched (isLoading)
  const showInitialLoading = isLoading || !rawData && !initialFetchError;
  const showEndReachedLabel = !showInitialLoading && !initialFetchError && totalCount > 0;
  const showNoResultView = !showInitialLoading && !initialFetchError && totalCount === 0;
  const [tileToFocusIndex, setTileToFocusIndex] = useState(-1);
  const source = useSource();
  const environment = useEnvironment();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isMpacWebCoherenceEnabled = enableMpacWebCoherence();
  const {
    handleTileClickAnalytics,
    handleLoadMoreClickAnalytics,
    handleClearAllFiltersAnalytics,
    handleFilterSelectionAnalytics,
    handleYourSearchQueryClickAnalytics
  } = useSearchPageAnalytics();
  const handleOnTileClick = (tileData, index) => {
    handleTileClickAnalytics({
      tileData,
      hitRank: index + 1,
      filters: analyticsFilters
    });
  };
  const handleLoadMoreClick = async event => {
    handleLoadMoreClickAnalytics({
      pageNumber: appList.length / PAGINATED_APP_GRID_CONFIG.fetchMoreCount,
      filters: analyticsFilters
    });
    await fetchMoreApps(event);

    // if load more is triggered via keypress, focus first newly loaded tile
    if (event.detail === 0) setTileToFocusIndex(appList.length);
  };
  const onClearFiltersClick = () => {
    handleClearAllFilters === null || handleClearAllFilters === void 0 ? void 0 : handleClearAllFilters();
    const {
        sort,
        query
      } = analyticsFilters,
      filters = _objectWithoutProperties(analyticsFilters, _excluded);
    handleClearAllFiltersAnalytics({
      filters
    });
  };
  const handleSortOptionSelect = sortOption => {
    onSortOptionSelect(sortOption);
    handleFilterSelectionAnalytics({
      filterType: 'sort',
      filterValue: sortOption.label
    });
  };
  const handleLinkClick = () => {
    var _searchInputRef$curre, _searchInputRef$curre2;
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
    handleYourSearchQueryClickAnalytics({
      query: (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 ? void 0 : _searchInputRef$curre2.value
    });
  };
  const handleTileToFocus = useCallback(ref => {
    if (ref) {
      ref.focus();
      setTileToFocusIndex(-1);
    }
  }, []);
  if (showNoResultView) {
    return /*#__PURE__*/_jsx(NoResultView, {
      showClearFilterButton: areFiltersActive,
      onClearFiltersClick: onClearFiltersClick,
      title: "We couldn't find a match for your query!",
      description: areFiltersActive ? 'Try rephrasing or changing your selection of filters' : 'Try rephrasing or search with another query'
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!initialFetchError && /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsxs(GridHeader, {
        className: ax([isMpacWebCoherenceEnabled && "_u5gg1e76"]),
        style: {
          "--_15020q": ix("var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-0, 0px)"))
        },
        children: [/*#__PURE__*/_jsx(MatchingResultLabel, {
          isSearchQueryActive: isSearchQueryActive,
          totalCount: totalCount,
          isLoading: showInitialLoading,
          areFiltersActive: areFiltersActive
        }), !isMobile && /*#__PURE__*/_jsx(SortDropdown, {
          onSortOptionSelect: handleSortOptionSelect,
          selectedSortKey: selectedSortKey
        })]
      })]
    }), /*#__PURE__*/_jsx(PaginatedAppGrid, {
      isLoading: showInitialLoading,
      isLoadingMore: isLoadingMore,
      onLoadMoreClick: handleLoadMoreClick,
      showLoadMoreButton: showLoadMoreButton,
      renderGrid: () => appList.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
        tileData: app,
        environment: environment,
        source: source,
        onTileClick: () => handleOnTileClick(app, index),
        tileRef: index === tileToFocusIndex ? handleTileToFocus : undefined,
        isAppInstalled: isAppInstalled,
        preferredHosting: selectedHostingFilter
      }, app.name)),
      fetchMoreError: fetchMoreError,
      initialFetchError: initialFetchError
    }), showEndReachedLabel && /*#__PURE__*/_jsx(EndPageLabel, {
      onLinkClick: handleLinkClick
    })]
  });
}